import * as actionTypes from './settingsActionType';

export const taxInvoiceSettingsRequest = (payload: actionTypes.TaxInvoiceSettingsRequest): actionTypes.TaxInvoiceSettingsRequestAction => {
  return {
    type: actionTypes.TAX_INVOICE_SETTINGS_REQUEST,
    payload,
  };
};

export const taxInvoiceSettingsSuccess = (payload: {
  data: actionTypes.TaxInvoiceSettingsResponse;
  status: number;
  message: string;
}): actionTypes.TaxInvoiceSettingsSuccessAction => {
  return {
    type: actionTypes.TAX_INVOICE_SETTINGS_SUCCESS,
    payload,
  };
};

export const taxInvoiceSettingsError = (message: string, error?: any): actionTypes.TaxInvoiceSettingsErrorAction => {
  return {
    type: actionTypes.TAX_INVOICE_SETTINGS_ERROR,
    payload: {
      message,
      error,
    },
  };
};

export const taxInvoiceSettingsReset = (): actionTypes.TaxInvoiceSettingsResetAction => {
  return {
    type: actionTypes.TAX_INVOICE_SETTINGS_RESET,
  };
};

